import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-liquid-container',
  imports: [],
  templateUrl: './liquid-container.html',
  styleUrl: './liquid-container.scss',
})
export class LiquidContainer {
  @Input() containerClass = '';
}
